import { contentAPI } from "../../api";

const DEFAULT_STATE = {
  data: {},
  isLoading: false,
  hasError: false,
  hasLoadedAll: false,
};

// Actions
export const types = {
  SET_CONTENT: "gulftree/content/SET_CONTENT",
  SET_CONTENT_PAGE: "gulftree/content/SET_CONTENT_PAGE",
  SET_CONTENT_IS_LOADING: "gulftree/content/SET_CONTENT_IS_LOADING",
  SET_CONTENT_HAS_ERROR: "gulftree/content/SET_CONTENT_HAS_ERROR",
};

// Reducer
export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case types.SET_CONTENT:
      return {
        ...state,
        data: {
          ...action.payload,
        },
        hasLoadedAll: true,
      };

    case types.SET_CONTENT_PAGE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.slug]: action.payload,
        },
      };

    case types.SET_CONTENT_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case types.SET_CONTENT_HAS_ERROR:
      return {
        ...state,
        hasError: action.payload,
      };

    default:
      return state;
  }
}

// Action Creators
export function fetchContent() {
  return (dispatch) => {
    dispatch({ type: types.SET_CONTENT_IS_LOADING, payload: true });
    dispatch({ type: types.SET_CONTENT_HAS_ERROR, payload: false });

    return contentAPI
      .fetchContent()
      .then((res) => {
        dispatch({ type: types.SET_CONTENT, payload: res });
        dispatch({ type: types.SET_CONTENT_HAS_ERROR, payload: false });
        dispatch({ type: types.SET_CONTENT_IS_LOADING, payload: false });
      })
      .catch((err) => {
        dispatch({ type: types.SET_CONTENT_HAS_ERROR, payload: true });
        dispatch({ type: types.SET_CONTENT_IS_LOADING, payload: false });
      });
  };
}

export function fetchPage(slug) {
  return (dispatch) => {
    dispatch({ type: types.SET_CONTENT_IS_LOADING, payload: true });
    dispatch({ type: types.SET_CONTENT_HAS_ERROR, payload: false });

    return contentAPI
      .fetchPage(slug)
      .then((res) => {
        dispatch({ type: types.SET_CONTENT_PAGE, payload: res });
        dispatch({ type: types.SET_CONTENT_HAS_ERROR, payload: false });
        dispatch({ type: types.SET_CONTENT_IS_LOADING, payload: false });
      })
      .catch((err) => {
        dispatch({ type: types.SET_CONTENT_HAS_ERROR, payload: true });
        dispatch({ type: types.SET_CONTENT_IS_LOADING, payload: false });
      });
  };
}
